var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 560 560"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 669.847,
    height: 670,
    x: -55.001,
    y: -55
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(27.5px)",
      clipPath: "url(#Ellipse_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    fillOpacity: 0.1,
    d: "M398.851 114.307c24.493-34.147 16.756-82.857-22.712-97.285a280 280 0 1 0 183.664 273.472c1.576-41.993-40.587-67.582-81.462-57.828-68.505 16.349-120.54-61.131-79.49-118.359",
    "data-figma-bg-blur-radius": 55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Ellipse_svg__a",
    transform: "translate(55 55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.851 114.307c24.493-34.147 16.756-82.857-22.712-97.285a280 280 0 1 0 183.664 273.472c1.576-41.993-40.587-67.582-81.462-57.828-68.505 16.349-120.54-61.131-79.49-118.359"
  })))));
};
export default SvgEllipse;